import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Image from "../../Elements/Image/Image.tsx";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import parse from "html-react-parser";
import useDisappearOnScrollDown from "./hooks/useDisappearOnScrollDown.ts";
import useOrganization from "hooks/useOrganization.ts";
import { useEffect, useRef, useState } from "react";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import Button, {
  ButtonAccessability,
} from "components/Elements/Button/Button.js";
import config from "config";
import { useModal } from "contexts/modalContext/modalContext.js";
import Login from "components/Structure/Login/Login.js";
import HomeIntegrateSectionImagesAnimation from "./Reusable/HomeIntegrateSectionImagesAnimation.jsx";
import { HomePartnersSection } from "./Reusable/HomePartnersSection/HomePartnersSection.tsx";

export const HomeContent = () => {
  const { mobileCondition, tabletCondition } = useMediaQueries();
  const {
    getTextByKey,
    getHtmlByKey,
    getLanguage,
    getBlackFridayTimeCookie,
    getPath,
  } = useContent();
  const { setModal } = useModal();
  const { getIsIsrael, isLoggedIn } = useUser();
  const scrollRef = useRef();
  const [faq, setFaq] = useState();

  useDisappearOnScrollDown(".discover-jumbomail-home");
  const { checkCurrDomainIsOrgDomain } = useOrganization();

  const scrollHandle = () => {
    const cords = scrollRef.current?.getBoundingClientRect();

    if (!cords) return;

    window.scrollTo({
      top:
        cords.top +
        window.pageYOffset -
        90 -
        (getBlackFridayTimeCookie() ? 70 : 0),
      behavior: "smooth",
    });
  };

  const getFaq = async () => {
    const res = await apiRequest("FAQ", "GetFAQByCulture", {
      faqCulture: getLanguage(),
    });
    if (res.status === "success") {
      setFaq(res.data);
    }
  };

  useEffect(() => {
    getFaq();
  }, []);

  const handleClickStartNow = () => {
    if (!isLoggedIn()) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
      return;
    }

    window.open(`${config.baseurl}${getPath()}inbox`, "_blank");
  };

  return checkCurrDomainIsOrgDomain() ? null : (
    <div className="home-content">
      <div className="discover-jumbomail-home">
        <ButtonAccessability
          buttonClassName="discover-jumbomail-home-icon ripple-effect"
          onClick={scrollHandle}
          title={getTextByKey("discover-jumbomail-button")}
        >
          <div className="circle"></div>
        </ButtonAccessability>
        <div className="discover-jumbomail-home-text" onClick={scrollHandle}>
          {getTextByKey("discover-jumbomail-button")}
        </div>
        <div className="discover-jumbomail-home-decoration"></div>
      </div>
      <div className="title-clouds" ref={scrollRef}>
        {/* <h1 className="title">{getTextByKey("discover-jumbomail")}</h1> */}
        <h1 className="title">{getTextByKey("new-home-promo-title")}</h1>
        <div className="col-content">{getHtmlByKey("new-home-promo-text")}</div>
        <iframe
          width="560"
          height="315"
          src={"https://www.youtube.com/embed/ubGjT1_5S9I?rel=0"}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
        <div className="home-clouds-container">
          {!mobileCondition && !tabletCondition && (
            <Image name="decoration-clouds-left" ext="png" hideTitle={true} />
          )}
          <Image name="decoration-clouds-right" ext="png" hideTitle={true} />
        </div>
      </div>
      <div className="main-content">
        <div className="double-column">
          <div className="col-1">
            <h2 className="col-title">
              {getHtmlByKey("home-bottom-content-title-one")}
            </h2>
            <div className="col-content">
              {getHtmlByKey("home-bottom-content-text-one")}
            </div>
          </div>
          <div className="col-2">
            <Image name="home/1000-white" ext="png" />
          </div>
        </div>
        <div className="double-column img-first">
          <div className="col-1">
            <Image name="subscribers/screen1" ext="png" />
          </div>
          <div className="col-2">
            <h2 className="col-title">
              {getHtmlByKey("home-bottom-content-title-two")}
            </h2>
            <div className="col-content">
              {getHtmlByKey("home-bottom-content-text-two")}
            </div>
            <LinkToNewTab
              page={"gallery/793349553070744966622F464B3342347436653838673D3D"}
              isNewTab
              classes="jm-button"
            >
              {getTextByKey("home-bottom-content-button-two")}
            </LinkToNewTab>
          </div>
        </div>
        <div className="double-column">
          <div className="col-1">
            <h2 className="col-title">
              {getHtmlByKey("home-bottom-content-title-three")}
            </h2>
            <div className="col-content">
              {getHtmlByKey("home-bottom-content-text-three")}
            </div>
            <LinkToNewTab
              page={"gallery/674278726E795A454B6450464B3342347436653838673D3D"}
              isNewTab
              classes="jm-button"
            >
              {getTextByKey("home-bottom-content-button-three")}
            </LinkToNewTab>
          </div>
          <div className="col-2">
            <Image name="home/home_preview_bottom_section" ext="png" />
          </div>
        </div>
        {getIsIsrael() ? (
          <div className="double-column img-first">
            <div className="col-1">
              <Image name="home/home_sell_bottom_section" ext="png" />
            </div>
            <div className="col-2">
              <h2 className="col-title">
                {getHtmlByKey("home-bottom-content-title-four")}
              </h2>
              <div className="col-content">
                {getHtmlByKey("home-bottom-content-text-four")}
              </div>
              <LinkToNewTab page={"jumbo-pay"} isNewTab classes="jm-button">
                {getTextByKey("home-bottom-content-button-four")}
              </LinkToNewTab>
            </div>
          </div>
        ) : null}
        <div className="single-column">
          <h2 className="col-title">
            {getHtmlByKey("home-bottom-content-title-five")}
          </h2>
          <div className="col-content">
            {getHtmlByKey("home-bottom-content-text-five")}
          </div>
          <HomeIntegrateSectionImagesAnimation />
          <h3 className="col-sub-title">
            {getHtmlByKey("home-bottom-content-sub-title-five")}
          </h3>
          <div className="col-content">
            {getHtmlByKey("home-bottom-content-sub-text-five")}
          </div>
          <LinkToNewTab page={"jumbo-forms"} isNewTab classes="jm-button">
            {getTextByKey("home-bottom-content-button-five")}
          </LinkToNewTab>
        </div>
        <div className="double-column">
          <div className="col-1">
            <h2 className="col-title">
              {getHtmlByKey("home-bottom-content-title-six")}
            </h2>
            <div className="col-content">
              {getHtmlByKey("home-bottom-content-text-six")}
            </div>
            <Button classes="jm-button" onClick={handleClickStartNow}>
              {getTextByKey("home-bottom-content-button-six")}
            </Button>
          </div>
          <div className="col-2">
            <Image name="home/home_manage_bottom_section" ext="png" />
          </div>
        </div>
      </div>
      <HomePartnersSection />
      <div className="additional-content">
        <h2 className="col-title">{getHtmlByKey("home-faq-title")}</h2>
        <div className="col-subtitle">{getHtmlByKey("home-faq-text")}</div>
        <div className="faq-content">
          {faq?.map((item, index) => (
            <div className="faq-item" key={index}>
              <h3 className="faq-item-title">{parse(item.FAQTitle)}</h3>
              <div className="faq-item-text">{parse(item.FAQText)}</div>
            </div>
          ))}
        </div>
        <div className="faq-footer">{getHtmlByKey("home-faq-footer")}</div>
      </div>
    </div>
  );
};
